/* Display estimates only. Shopify product prices and checkout remain untouched.
 * Reference parity checked 2026-09-27: USD 1 = SAR 3.75 = AED 3.6725.
 * Sources: SAMA exchange-rate policy; CBUAE published exchange rates.
 */
(() => {
  'use strict';
  const configElement = document.getElementById('EnginoraCurrencyConfig');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch (_) { return; }
  if (config.base !== 'SAR') return;
  const rates = Object.freeze({ SAR: 1, AED: 3.6725 / 3.75, USD: 1 / 3.75 });
  const storageKey = 'enginora-display-currency-v1';
  const originals = new WeakMap();
  const supported = value => Object.prototype.hasOwnProperty.call(rates, value);
  let currency = 'SAR';
  try {
    const stored = window.localStorage.getItem(storageKey);
    if (supported(stored)) currency = stored;
  } catch (_) { /* Currency selection still works when storage is unavailable. */ }
  const format = (cents, code) => new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2, maximumFractionDigits: 2
  }).format(cents / 100 * rates[code]) + ' ' + code;

  function updateMoney(element) {
    const raw = element.dataset.moneyCents;
    const source = element.dataset.moneySource;
    const cents = Number(raw);
    if (source !== 'SAR' || raw == null || raw === '' || !Number.isSafeInteger(cents) || cents < 0) return;
    let original = originals.get(element);
    if (!original || original.raw !== raw) {
      original = { raw, text: element.textContent };
      originals.set(element, original);
    }
    const converted = currency !== 'SAR';
    element.textContent = converted ? '≈ ' + format(cents, currency) : original.text;
    element.setAttribute('dir', 'ltr');
    element.classList.toggle('enginora-money-estimate', converted);
    if (converted) element.title = config.checkoutNote;
    else element.removeAttribute('title');
  }

  function updateInstallmentEstimates() {
    document.querySelectorAll('[data-bnpl-estimate]').forEach(container => {
      const section = container.closest('[data-product-section]');
      const productMoney = section?.querySelector('[data-product-price] [data-display-money]');
      const selected = section?.querySelector('[data-variant-select]')?.selectedOptions[0];
      if (selected) container.hidden = selected.dataset.available !== 'true';
      const cents = Number(productMoney?.dataset.moneyCents);
      if (!productMoney || productMoney.dataset.moneySource !== 'SAR' || !Number.isSafeInteger(cents) || cents < 0) return;
      const installmentCents = Math.round(cents / 4);
      container.querySelectorAll('[data-installment-money]').forEach(element => {
        const raw = String(installmentCents);
        if (element.dataset.moneyCents === raw) return;
        element.dataset.moneyCents = raw;
        element.textContent = format(installmentCents, 'SAR');
      });
    });
  }

  function refresh() {
    updateInstallmentEstimates();
    document.querySelectorAll('[data-display-money]').forEach(updateMoney);
    document.querySelectorAll('[data-currency-select]').forEach(select => { select.value = currency; });
    document.querySelectorAll('[data-currency-control]').forEach(control => { control.hidden = false; });
    document.querySelectorAll('[data-currency-note]').forEach(note => { note.hidden = currency === 'SAR'; });
  }
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-currency-select]');
    if (!select) return;
    currency = supported(select.value) ? select.value : 'SAR';
    try { window.localStorage.setItem(storageKey, currency); } catch (_) { /* No persistence required. */ }
    refresh();
  });
  document.addEventListener('enginora:prices-updated', refresh);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    currency = supported(event.newValue) ? event.newValue : 'SAR';
    refresh();
  });
  refresh();
})();
